import { render, staticRenderFns } from "./appHeader0.vue?vue&type=template&id=31a81341"
import script from "./appHeader0.vue?vue&type=script&lang=js"
export * from "./appHeader0.vue?vue&type=script&lang=js"
import style0 from "./appHeader0.vue?vue&type=style&index=0&id=31a81341&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports